import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-location',
	templateUrl: './location.component.html',
	styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('locationForm', { static: true }) locationForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	locationFormSubscription: Subscription;
	font;
	newapi = false;
	isAdmin;
	isModalShown: Boolean = false;
	fonts: Array<Font>;
	multipleMapsList = [
		{
			key: '1',
			label: 'One'
		},
		{
			key: '2',
			label: 'Two'
		},
		{
			key: '3',
			label: 'Three'
		},
		{
			key: 'unlimited',
			label: 'Unlimited'
		}
	];
	dimensionsTooltip = '';
	dimensionsTooltipDisabled = 'Disabled. To use set the "Fallback Location" to "Custom Image"';

	constructor(
		private comService: ComponentService,
		private overlay: OverlayService,
		private fontsService: FontsService,
		private auth: AuthService
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		if (this.componentData.config.version >= 2 && this.componentData.config.newapi) {
			this.newapi = true;
		}

		this.componentData.config.responsive = this.componentData.config.responsive == 1 ? 1 : 0;

		this.componentData.config.location_pin_count = this.componentData.config.location_pin_count
			? this.componentData.config.location_pin_count
			: this.multipleMapsList[0].key;

		this.font = this.componentData.config.text.font;
		this.fonts = this.fontsService.getFonts();

		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.text.font;

		this.locationFormSubscription = this.locationForm.valueChanges
			.pipe(
				tap(() => {
					this.dimensionsTooltip =
						this.componentData.config.locations[0].image_type == 'Custom' ? '' : this.dimensionsTooltipDisabled;
					this.comService.updateDisabledSave(this.locationForm.invalid || this.nameField.editComponentName);
					this.comService.updateComponentData(this.componentData);
				}),
				filter((form) => this.locationForm.dirty && this.locationForm.valid),
				debounceTime(1000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.locationFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	addStore() {
		if (this.componentData.config.locations.length < 101) {
			this.componentData.config.locations.push({
				address: '',
				lat: '',
				lng: '',
				link: '',
				image_type: 'Google',
				image: '',
				icon_color: 'red'
			});
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum limit of 100 locations', 'alert');
		}
	}

	onAddressChange(event, index) {
		this.componentData.config.locations[index].lat = event.lat;
		this.componentData.config.locations[index].lng = event.lng;
		this.componentData.config.locations[index].address = event.address;
	}

	checkNavigationLink(index) {
		if (this.componentData.config.locations[index].link_type == 'Navigation') {
			this.componentData.config.locations[index].link_type = 'None';
		}
	}

	removeStore(index) {
		this.componentData.config.locations.splice(index, 1);
	}

	onNoRadiusChange(val) {
		this.componentData.config.no_radius = val;
		this.locationForm.controls['radius'].setValue(val ? 20 : this.componentData.config.radius);
	}

	changeDimensions(event) {
		this.componentData.config.item_width = event.width;
		this.componentData.config.item_height = event.height;
	}

	autoDimensionCheck() {
		this.componentData.config.locations[0]['image_type'] = 'Custom';
	}
}
